import { ICommandBase } from "@Quest/cqrs";

export class CreateCapexAccountCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Capex.Commands.CreateCapexAccountCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string;	
	Classification: string;
	constructor(workspaceId: number, strategyId: string, capexId: string, name: string, description: string, classification: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = capexId;
		this.Name = name;
		this.Description = description;
		this.Classification = classification;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Capex.Commands.CreateCapexAccountCommandV1, TCh.Domain.Quest';
	}
}
export class DeleteCapexAccountCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Capex.Commands.DeleteCapexAccountCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	constructor(workspaceId: number, strategyId: string, capexId: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = capexId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Capex.Commands.DeleteCapexAccountCommandV1, TCh.Domain.Quest';
	}
}
export class UpdateCapexAccountCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Capex.Commands.UpdateCapexAccountCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string;
	Classification: string;

	constructor(workspaceId: number, strategyId: string, capexId: string, name: string, description: string, classification: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = capexId;
		this.Name = name;
		this.Description = description;
		this.Classification = classification;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Capex.Commands.UpdateCapexAccountCommandV1, TCh.Domain.Quest';
	}
}
